import { render, staticRenderFns } from "./HotelsAdvancedDetailPaymentPolicy.vue?vue&type=template&id=286b3281&scoped=true&"
import script from "./HotelsAdvancedDetailPaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./HotelsAdvancedDetailPaymentPolicy.vue?vue&type=script&lang=js&"
import style0 from "./HotelsAdvancedDetailPaymentPolicy.vue?vue&type=style&index=0&id=286b3281&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b3281",
  null
  
)

export default component.exports